//constants
import { MAX_COLOR, TEXT_MORE } from './constants';

export const getQuanityMessage = (length: number) =>
  length - MAX_COLOR > 0 ? `+${length - MAX_COLOR} ${TEXT_MORE}` : '';
